import { TextStyle } from '@able/react';
import classNames from 'classnames';
import './spinner.css';

export function Spinner({ className, label }) {
    return (
        <div class={classNames('refresh_spinner', className)}>
            <div class='loader' aria-label={label}><svg class='circular'><circle class='path' /></svg></div>
        </div>
    );
}

export function SpinnerWithMessage({ spinnerClassName, className, label }) {
    return (
        <div className={classNames('spinner-with-messaage', className)}>
            <Spinner className={spinnerClassName} label={label} />
            <TextStyle className="mt-5" alias="LabelA1">Please don't close the window.</TextStyle>
            <TextStyle alias="Base">This may take up to 10 seconds.</TextStyle>
        </div>
    );
}
